var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('svg',{attrs:{"width":"64px","height":"64px"}},[_c('circle',{attrs:{"cx":"31.5px","cy":"31.5px","r":"31.5px","fill":"#2289E9"}}),_c('text',{attrs:{"x":"50%","y":"50%","fill":"white","text-anchor":"middle","dominant-baseline":"middle"}},[_vm._v(" "+_vm._s(_vm.inputText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }